import type { TOC } from '@ember/component/template-only'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { t } from 'ember-intl'
import type ResearchReportsController from 'teacher-ui-client/subscription-type/quick-links/research-reports/controller'
import { ResearchReportTile } from 'teacher-ui-client/components/research-report-tile'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    controller: ResearchReportsController
  }
}
export const QuickLinksResearchReportsPage: TOC<Signature> = <template>
  <div class="my-8 w-full px-8">

    <PageHeader>
      <:title>
        <h1>
          {{t "quickLinks.pageTitles.researchReports"}}
        </h1>
      </:title>
    </PageHeader>

    <div class="flex flex-wrap justify-center overflow-hidden">
      {{#each @controller.researchReports as |researchReport|}}
        <ResearchReportTile
          class="m-2"
          @title={{researchReport.title}}
          @description={{researchReport.description}}
          @coverUrl={{researchReport.coverUrl}}
          @fileUrl={{researchReport.fileUrl}}
        />
      {{/each}}
    </div>
  </div>
</template>

export default RouteTemplate(QuickLinksResearchReportsPage)
